import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { userAuthApi } from "../services/userAuthApi";
import { LoginUser, Response } from "Data/interfaces";
import { removeSecureLocalStorage, removeToken, setSecureLocalStorage } from "Data/services/localStorageService";

interface AuthState {
  user: LoginUser | null;
  isLoggedIn: boolean;
  isSocketConnected: boolean;
}

const initialState: AuthState = {
  user: null,
  isLoggedIn: false,
  isSocketConnected: false
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload }
    },
    logout: () => {
      removeSecureLocalStorage('authUser')
      removeToken()
      return initialState
    },
    socketConntected: (state) => {
      state.isSocketConnected = true
    }
    //  setAuthInfo:(state, action)=> {
    //     state.token = action.payload.token;
    //     state.csrf_token = action.payload.csrf_token;
    //   },
    //   unsetAuthInfo:(state, action)=> {
    //     state.token = action.payload.token;
    //     state.csrf_token = action.payload.csrf_token;
    //  },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userAuthApi.endpoints.loginUser.matchFulfilled,
        (state, { payload }: PayloadAction<Response<LoginUser>>) => {
          state.user = payload.data;
          state.isLoggedIn = true;
          state.isSocketConnected = false
          setSecureLocalStorage("authUser", payload.data as unknown as string);
        }
      )
      .addMatcher(
        userAuthApi.endpoints.toggleNotification.matchFulfilled,
        (state, { payload }: PayloadAction<Response<LoginUser>>) => {
          state.user = payload.data;
          setSecureLocalStorage("authUser", payload.data as unknown as string);
        }
      )
      .addMatcher(
        userAuthApi.endpoints.getProfile.matchFulfilled,
        (state, { payload }: PayloadAction<Response<LoginUser>>) => {
          state.user = payload.data;
          setSecureLocalStorage("authUser", payload.data as unknown as string);
        }
      )
      .addMatcher(
        userAuthApi.endpoints.updateProfile.matchFulfilled,
        (state, { payload }: PayloadAction<Response<LoginUser>>) => {
          state.user = payload.data;
          setSecureLocalStorage("authUser", payload.data as unknown as string);
        }
      )
      .addMatcher(userAuthApi.endpoints.loginUser.matchRejected, (state) => {
        state.user = null;
      })
      .addMatcher(userAuthApi.endpoints.logout.matchFulfilled, (state) => {
        state.user = null;
      });
  },
});

export const { updateUser, logout, socketConntected } = authSlice.actions;

export default authSlice.reducer;
